import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Select } from 'antd';
import moment from 'moment-timezone/builds/moment-timezone-with-data';

const { Option } = Select;

const TimezoneSelector = ({
    selectStyle = { width: 150, height: '100%' },
    selectClassnames = '',
    wrapperClass = 'timezoneSelect',
}) => {
    const dispatch = useDispatch();
    const { activeTimezone } = useSelector((state) => state?.settings);

    const renderOptions = () => {
        const timezones = moment.tz.names();
        let mappedValues = {};
        let regions = [];

        timezones.forEach((timezone) => {
            if (
                timezone.includes('/') &&
                !timezone.toLowerCase().includes('us/') && 
                !timezone.toLowerCase().includes('etc/')
            ) {
                const splitTimezone = timezone.split('/');
                const region = splitTimezone[0];
                if (!mappedValues[region]) {
                    mappedValues[region] = [];
                    regions.push(region);
                }
                mappedValues[region].push(timezone);
            }
        });

        return regions.flatMap((region) => {
            return mappedValues[region].map((timezone) => {
                return <Option key={timezone} value={timezone}>{timezone}</Option>;
            });
        });
    };

    return (
        <div className={wrapperClass}>
            <Select
                className={selectClassnames}
                style={selectStyle}
                showSearch
                allowClear={false}
                value={activeTimezone}
                onChange={(val) =>
                    dispatch({
                        type: 'SET_ACTIVE_TIMEZONE',
                        payload: val,
                    })
                }
                filterOption={(input, option) =>
                    option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                    optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                }
                optionFilterProp="children"
            >
                {renderOptions()}
            </Select>
            <style>{`
                .Onsite_Analytics .ant-select-selector { height: 100% !important; }
                @media screen and (max-width: 780px) {
                    .selectMobileView .ant-select-selection-item { display: flex !important; align-items: center !important; }
                    .selectMobileView .ant-select-selector { border-radius: 9px !important; height: 44px !important; }
                }
            `}</style>
        </div>
    );
};

export default TimezoneSelector;